import React, { useRef, useEffect } from "react";
import * as Icons from "lucide-react";
import { ICONS_BY_NAME } from "../lib/icons";
import { useConfirm } from "./ConfirmDialog";

export const RichTextEditor = ({ value, onChange, testid, placeholder = "Rédigez la réponse…" }) => {
  const ref = useRef(null);
  const { ask } = useConfirm();
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) ref.current.innerHTML = value || "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exec = (cmd, arg) => {
    document.execCommand(cmd, false, arg);
    ref.current.focus();
    onChange(ref.current.innerHTML);
  };
  // Saisie dans la fenêtre d'Horizon (décision du 30/09) au lieu de window.prompt. La fenêtre prend le focus :
  // la sélection du texte est mémorisée avant, puis rétablie pour que le lien s'applique au texte choisi.
  const addLink = async () => {
    const sel = window.getSelection();
    const range = sel && sel.rangeCount && ref.current.contains(sel.anchorNode) ? sel.getRangeAt(0).cloneRange() : null;
    const url = await ask({ title: "Insérer un lien", label: "Adresse du lien", defaultValue: "https://", confirmLabel: "Insérer", select: false });
    if (!url) return;
    ref.current.focus();
    if (range) { sel.removeAllRanges(); sel.addRange(range); }
    exec("createLink", url);
  };

  const Btn = ({ icon, title, onClick }) => (
    <button type="button" title={title} data-testid={`rte-${title}`} onMouseDown={(e) => e.preventDefault()} onClick={onClick}
      className="w-8 h-8 flex items-center justify-center rounded-sm text-marine hover:bg-marine-50 transition-colors">
      {React.createElement(ICONS_BY_NAME[icon], { size: 15 })}
    </button>
  );

  return (
    <div className="border border-marine/20 rounded-sm overflow-hidden">
      <div className="flex items-center gap-0.5 border-b border-marine/15 bg-creme px-1 py-1">
        <Btn icon="Bold" title="Gras" onClick={() => exec("bold")} />
        <Btn icon="Italic" title="Italique" onClick={() => exec("italic")} />
        <Btn icon="List" title="Liste à puces" onClick={() => exec("insertUnorderedList")} />
        <Btn icon="ListOrdered" title="Liste numérotée" onClick={() => exec("insertOrderedList")} />
        <Btn icon="Link" title="Lien" onClick={addLink} />
      </div>
      <div ref={ref} contentEditable data-testid={testid} data-placeholder={placeholder}
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="rich-content min-h-[160px] max-h-[340px] overflow-y-auto p-3 text-sm text-marine outline-none focus:ring-1 focus:ring-marine" />
    </div>
  );
};
